
import { defineComponent, onBeforeMount, ref } from "vue";

export default defineComponent({
  name: "Footer",
  setup() {
    const email = ref("");
    const phone = ref("");
    const logo = ref("");
    const instagram = ref("");
    const linkedin = ref("");
    const isCirculoTemplate = ref(false);

    onBeforeMount(async () => {
      await loadInformation();
    });

    const loadInformation = (): void => {
      switch (process.env.VUE_APP_THEME) {
        case "circulo":
          logo.value = require("../../../assets/static/companies_logos/ganhemais-white.svg");
          phone.value = "0800-648-2966";
          email.value = "sac.circulo@circulo.com.br";
          isCirculoTemplate.value = true;
          instagram.value = "https://www.instagram.com/circuloprodutos/";
          break;
        case "construcolor":
          logo.value = require("../../../assets/static/decola_logos/logo04_sem_slogan.svg");
          phone.value = "(47) 99918 - 7801";
          email.value = "midia@construcolor.com.br";
          instagram.value = "https://www.instagram.com/construcolor";
          linkedin.value = "https://www.linkedin.com/company/construcolor/";
          break;
        default:
          logo.value = require("../../../assets/static/decola_logos/logo04_sem_slogan.svg");
          phone.value = "(47) 3331 - 9700";
          email.value = "decola@lince.com.br";
          instagram.value = "https://www.instagram.com/lincetech/";
          linkedin.value =
            "https://br.linkedin.com/company/lince-participa%C3%A7%C3%B5es-e-empreendimentos-ltda";
      }
    };

    const getCurrentYear = (): number => {
      const currentDate = new Date();

      return currentDate.getFullYear();
    };

    return {
      email,
      logo,
      phone,
      instagram,
      linkedin,
      isCirculoTemplate,
      getCurrentYear
    };
  }
});
